import React from 'react'

/**
 * Lazy mount host for the v3 route (architecture D-2).
 *
 * App.js registers /masterplanograms/v3 itself (react-router v5 route
 * table) and must NOT import this module statically — it uses
 * React.lazy(() => import('componentsV2/simulationV3')) so the v3 chunk
 * is code-split and only fetched when the flag is on and the route is
 * visited. This file provides the lazy component in one place for that
 * registration.
 */
export const LazySimulationScreen = React.lazy(() => import('./index'))
